// ============================================================================
// CADERNO DE TRABALHO — STANDALONE VIEWER
// ARQUIVO: src/features/files/CadernoTrabalhoStandaloneViewer.jsx
// RESPONSABILIDADE: pop-out de verdade (janela do SO, arrastável pra outro
//   monitor) do Caderno de Trabalho, espelhando PecaStandaloneViewer.jsx
//   (Fase C5, 02/09/2026) — mesmo padrão (rota própria + window.open,
//   bootstrap sozinho a partir da URL), sem o toggle Normal/Redline (o
//   Caderno de Trabalho não tem esse conceito, é uma única fonte markdown).
//   Pedido do titular (15/09/2026): replicar "Nova Janela" + "Abrir no
//   Drive" do Caderno de Autos ("A Peça em Si") pro Caderno de Trabalho.
// ============================================================================

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { onSnapshot } from "firebase/firestore";
import { getWorkspaceDocRef } from "./CadernoCockpitRepository";
import { CadernoMarkdownViewer } from "./CadernoMarkdownViewer";

export default function CadernoTrabalhoStandaloneViewer() {
  const { workspaceId } = useParams();
  const [workspace, setWorkspace] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ref = getWorkspaceDocRef(workspaceId);
    if (!ref) {
      setLoading(false);
      return;
    }
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setWorkspace(snap.exists() ? { id: snap.id, ...snap.data() } : null);
        setLoading(false);
      },
      () => setLoading(false),
    );
    return () => unsub();
  }, [workspaceId]);

  const driveWebViewLink = String(workspace?.cadernoMdWebViewLink || "").trim();
  const caseLabel = String(workspace?.clientName || workspace?.numeroCNJ || "").trim() || "Caderno de Trabalho";

  useEffect(() => {
    document.title = `Caderno de Trabalho — ${caseLabel} — RDA`;
  }, [caseLabel]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <div className="bg-white border-b border-gray-200 px-5 py-3 flex items-center gap-3 shrink-0">
        <i className="fas fa-book-open text-[#C5A059]" aria-hidden="true"></i>
        <h1 className="text-base font-bold text-[#20243B] truncate">
          Caderno de Trabalho — {caseLabel}
        </h1>
      </div>
      <div className="flex-1 min-h-0 p-5">
        <div className="max-w-4xl mx-auto h-full">
          {loading ? (
            <div className="text-center text-xs text-gray-400 py-16">
              <i className="fas fa-spinner fa-spin mr-1.5"></i> Carregando...
            </div>
          ) : !driveWebViewLink ? (
            <div className="text-center text-xs text-gray-400 py-16">
              Caderno de Trabalho ainda não foi gerado para este caso.
            </div>
          ) : (
            <CadernoMarkdownViewer driveWebViewLink={driveWebViewLink} />
          )}
        </div>
      </div>
    </div>
  );
}
